import React, { useEffect, useState } from 'react';
import { Accordion, Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Sidebar.css';
import T8_versionmanager_menu from './menus/T8_versionmanager_menu';
import T8_logistics from './menus/T8_logistics';
import T8_crm from './menus/T8_crm';
import T8_talent_mnu from './menus/T8_talent_mnu';
import T8_projects_mnu from './menus/T8_projects_mnu';
import T8_pins_mnu from './menus/T8_pins_mnu';
import packageJsonData from '../../package.json'; // 1. Importa el objeto JSON completo
import Helpdesk from './menus/Helpdesk';
import T8_workshops_mnu from './menus/T8_workshops_mnu';
import T8_tomi8_api_menu from './menus/T8_tomi8_api_menu';
import { close_session } from '../utils/services';
import QuickLinks from './pages/dashboard/QuickLinks';



/**
 * Sidebar component
 * Props:
 *  - setactivity: function to set active menu item (optional)
 *  - devices_management, logistics, project_management, talent_metrics, user_admin, accountant: permission flags
 *  - version: app version string (pass from parent, e.g. from package.json)
 */
const activitySelectionMap = {
  TOMi8versions: { menuKey: '0', subKey: 'versions' },
  SubsistemaTOMi: { menuKey: '0', subKey: 'subsistema_tomi' },
  Models_Admin: { menuKey: '0', subKey: 'models' },
  Legacy: { menuKey: '0', subKey: 'legacy' },
  Despachos: { menuKey: '1', subKey: 'despachos' },
  Produccion: { menuKey: '1', subKey: 'produccion' },
  ProduccionDetail: { menuKey: '1', subKey: 'produccion' },
  Channels: { menuKey: '2', subKey: 'channels' },
  Channel_panel: { menuKey: '2', subKey: 'channels' },
  Opportunities: { menuKey: '2', subKey: 'opportunities' },
  OpportunityPage: { menuKey: '2', subKey: 'opportunities' },
  Qrshorter: { menuKey: '2', subKey: 'qrshorter' },
  Projects_relations: { menuKey: '3', subKey: 'projects_relations' },
  Project_admin: { menuKey: '3', subKey: 'project_admin' },
  Contractor: { menuKey: '3', subKey: 'contractor' },
  Instituciones: { menuKey: '3', subKey: 'instituciones' },
  Institucion_panel: { menuKey: '3', subKey: 'instituciones' },
  MassMessaging: { menuKey: '3', subKey: 'mass_messaging' },
  Units_status: { menuKey: '5', subKey: 'units_status' },
  Email_info: { menuKey: '5', subKey: 'helpdesk' },
  Cases_report: { menuKey: '5', subKey: 'helpdesk_report' },
  Expenses: { menuKey: '4', subKey: 'expenses' },
  Awards: { menuKey: '4', subKey: 'awards' },
  Strategylist: { menuKey: '4', subKey: 'strategylist' },
  Members_master: { menuKey: '4', subKey: 'members_master' },
  Stocks: { menuKey: '4', subKey: 'stocks' },
  Individual_stock: { menuKey: '4', subKey: 'individual_stock' },
  Premium_services: { menuKey: '4', subKey: 'premium_services' },
  Tacticfollowup: { menuKey: '4', subKey: 'tactic_followup' },
  Task_progress: { menuKey: '4', subKey: 'task_progress' },
  Statistics: { menuKey: '4', subKey: 'statistics' },
  Strategypage: { menuKey: '4', subKey: 'strategypage' },
  PinsLotes: { menuKey: '8', subKey: 'pins_lotes' },
  PinsGenerar: { menuKey: '8', subKey: 'pins_generar' },
  PinsValidar: { menuKey: '8', subKey: 'pins_validar' },
  PinsEstado: { menuKey: '8', subKey: 'pins_estado' },
  PinsLotesQA: { menuKey: '8', subKey: 'pins_lotes_qa' },
  PinsEstadoQA: { menuKey: '8', subKey: 'pins_estado_qa' },
  PinesCupones: { menuKey: '8', subKey: 'pins_cupones' },
  PinesCuponesQA: { menuKey: '8', subKey: 'pins_cupones_qa' },
  WorkshopsEditor: { menuKey: '9', subKey: 'workshops_editor' },
  WorkshopsCertificates: { menuKey: '9', subKey: 'workshops_certificates' },
  TOMi8Api: { menuKey: '10', subKey: 'tomi8_api_docs' },
  Admin_panel: { menuKey: '6', subKey: 'admin_panel' },
  Admin_products: { menuKey: '6', subKey: 'admin_products' }
};

const getSelectionForActivity = (activity) => {
  if (!activity) {
    return { menuKey: null, subKey: null };
  }

  return activitySelectionMap[activity] || { menuKey: null, subKey: null };
};

function Sidebar({
  setactivity,
  devices_management,
  logistics,
  project_management,
  talent_metrics,
  user_admin,
  accountant,
  helpdesk,
  crm,
  company_dashs,
  usr_type,
  pin_management,
  workshops,
  tomi8api,
  ies_management,
  manufacturing,
  current_activity,
  isCollapsed,
  userMenu
}) {
  const appVersion = packageJsonData.version;
  const navigate = useNavigate();
  const selection = getSelectionForActivity(current_activity);
  const [activeMenuKey, setActiveMenuKey] = useState(selection.menuKey);
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };

  const token = localStorage.getItem("token");

  useEffect(() => {
    setActiveMenuKey(selection.menuKey);
  }, [selection.menuKey]);

const cerrar_sesion = () => {
    async function fetchClose_session() {
        try {
            await close_session(token);
        } finally {
            localStorage.removeItem('token');
            navigate('/', { replace: true });
        }
    }
    fetchClose_session();
  }


  return (
    <div
      className="d-flex flex-column bg-light h-100 sidebar-collapsible"
      style={{
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}
    >
      <div className="sidebar-modern__nav">
      <Accordion activeKey={activeMenuKey || undefined} onSelect={setActiveMenuKey} flush className="sidebar-modern__accordion">
        {devices_management !== '0' && (
          <T8_versionmanager_menu
            permission={devices_management}
            setactivity={setactivity}
            activeItem={selection.subKey}
          />
        )}
        {(logistics !== '0' || (manufacturing && manufacturing !== '0')) && (
          <T8_logistics
            permission={logistics}
            manufacturing={manufacturing}
            setactivity={setactivity}
            activeItem={selection.subKey}
          />
        )}
        {crm !== '0' && (
          <T8_crm
            permission={crm}
            usr_type={usr_type}
            setactivity={setactivity}
            activeItem={selection.subKey}
          />
        )}
        {(project_management !== '0' || (ies_management && ies_management !== '0')) && (
          <T8_projects_mnu
            permission={talent_metrics}
            project_management={project_management}
            ies_management={ies_management}
            setactivity={setactivity}
            activeItem={selection.subKey}
          />
        )}
        {talent_metrics !== '0' && (
          <T8_talent_mnu
            permission={talent_metrics}
            setactivity={setactivity}
            activeItem={selection.subKey}
          />
        )}
        {helpdesk !== '0' && (
          <Helpdesk
            permission={helpdesk}
            setactivity={setactivity}
            activeItem={selection.subKey}
          />
        )}
        {pin_management !== '0' && (
          <T8_pins_mnu
            permission={pin_management}
            setactivity={setactivity}
            activeItem={selection.subKey}
          />
        )}
        {workshops !== '0' && (
          <T8_workshops_mnu
            setactivity={setactivity}
            activeItem={selection.subKey}
          />
        )}
        {Number(tomi8api) === 1 && (
          <T8_tomi8_api_menu setactivity={setactivity} activeItem={selection.subKey} />
        )}

        {user_admin !== '0' && (
          <Accordion.Item eventKey="6">
            <Accordion.Header>
              <span role="img" aria-label="admin">🔧</span> Administrador
            </Accordion.Header>
            <Accordion.Body className="p-0">
              <Nav className="flex-column">
                <Nav.Link
                  active={selection.subKey === 'admin_panel'}
                  style={selection.subKey === 'admin_panel' ? activeStyles : undefined}
                  onClick={() => navigate('/Admin_panel')}
                >
                  Panel Admin
                </Nav.Link>
                <Nav.Link
                  active={selection.subKey === 'admin_products'}
                  style={selection.subKey === 'admin_products' ? activeStyles : undefined}
                  onClick={() => navigate('/Admin_products')}
                >
                  Productos
                </Nav.Link>
              </Nav>
            </Accordion.Body>
          </Accordion.Item>
        )}

        {accountant !== '0' && (
          <Accordion.Item eventKey="7">
            <Accordion.Header>
              <span role="img" aria-label="accountant">💼</span> Contabilidad
            </Accordion.Header>
            <Accordion.Body className="p-0">
              <Nav className="flex-column">
                <Nav.Link onClick={() => navigate('/Reports')}>Reportes</Nav.Link>
              </Nav>
            </Accordion.Body>
          </Accordion.Item>
        )}
      </Accordion>
      </div>

      <div className="sidebar-modern__footer">
        {parseInt(usr_type) === 0 && (
        <div className="sidebar-modern__quick-links">
          <QuickLinks />
        </div>
        )}
        {userMenu}
        <button type="button" className="sidebar-modern__logout" onClick={cerrar_sesion}>
          Cerrar sesión
        </button>
        {appVersion && <span className="sidebar-modern__version">v{appVersion}</span>}
      </div>
    </div>
  );
}

export default Sidebar;
